var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0C5.14871 0 0 5.14871 0 11.5C0 17.8513 5.14871 23 11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14871 17.8513 0 11.5 0ZM11.5 2.22581C16.6255 2.22581 20.7742 6.37374 20.7742 11.5C20.7742 16.6255 16.6263 20.7742 11.5 20.7742C6.37452 20.7742 2.22581 16.6263 2.22581 11.5C2.22581 6.37452 6.37374 2.22581 11.5 2.22581ZM18.0014 8.26641L16.9564 7.21296C16.74 6.99478 16.3876 6.99334 16.1695 7.2098L9.61483 13.7118L6.84222 10.9167C6.62581 10.6985 6.27348 10.697 6.05531 10.9135L5.0018 11.9585C4.78363 12.1749 4.78219 12.5272 4.99865 12.7454L9.20825 16.9891C9.42467 17.2073 9.77699 17.2087 9.99517 16.9923L17.9983 9.05338C18.2164 8.83692 18.2178 8.48459 18.0014 8.26641Z",
    fill: "#FD8533"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/check-mark.611cde6df166959b1898abc33086074c.svg";
export { ForwardRef as ReactComponent };